import { render, staticRenderFns } from "./LftRghtBtns.vue?vue&type=template&id=1f1763b3&scoped=true&"
import script from "./LftRghtBtns.vue?vue&type=script&lang=js&"
export * from "./LftRghtBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1763b3",
  null
  
)

export default component.exports